module.exports = __webpack_public_path__ + "media/assets/icons/asleep-c6c356b76bd9ac01c5cc435a3c2c3a5a.svg";